
    exports.datatypes = require('./util/datatypes');




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/util.js
// module id = 4653
// module chunks = 15